module.exports = __webpack_public_path__ + "img/fecha.5232819b.svg";